import React, { FC } from 'react';

import './FleetHighlightSection.scss';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import { useMediaQuery } from 'usehooks-ts';

const FleetMaximise = ({ fields }) => {
  const isMobile = useMediaQuery('(max-width: 480px)');
  const carImage = isMobile ? fields?.mobileImage : fields?.image;
  return (
    <div className={'container fleet-maximise'}>
      <div className={'containerMaximise'} data-aos="fade-up">
        <div className={'wrapper'}>
          <Image field={carImage} alt="Hero background" className={'backgroundImage'} />
          <div className={'containerContent'}>
            <div className={'containerText'}>
              {/* <BlockRendererClient content={highlightSectionData.text} /> */}
              <h1>
                <RichText field={fields.titleRichText} />
              </h1>
              <p>{fields.desc?.value}</p>
            </div>
            <div className={'containerLink'}>
              <a className={'pcButton'} href={fields?.buttonUrl?.value?.href}>
                {fields?.buttonText?.value}
              </a>
            </div>
          </div>
        </div>

        <a className={'laptopButton'} href={fields?.buttonUrl?.value?.href}>
          {fields?.buttonText?.value}
        </a>
      </div>
    </div>
  );
};

export default FleetMaximise;
